import React from 'react';
import { MeasureDisplayFormatOperator } from '../../../utils/apollo/graphqlSchema';
import * as MeasureDisplayFormatUI from './MeasureDisplayFormatUI';
import { measureDisplayFormatCalculationUnitLookup } from '../../../utils/builder/measures/measureDisplayFormat/utils';

interface IProps {
  value: MeasureDisplayFormatOperator | null;
  onChange: (value: MeasureDisplayFormatOperator) => void;
}

const options: MeasureDisplayFormatOperator[] = [
  MeasureDisplayFormatOperator.Divide,
  MeasureDisplayFormatOperator.Multiply,
];

const MeasureDisplayFormatCalculationUnit = ({ value, onChange }: IProps) => {
  return (
    <MeasureDisplayFormatUI.CalculationUnitMenu
      value={value || ''}
      placeholder="Select"
      onChange={(value) => onChange(value as MeasureDisplayFormatOperator)}
      options={options.map((option) => ({
        value: option,
        text: measureDisplayFormatCalculationUnitLookup[option],
      }))}
    />
  );
};

export default MeasureDisplayFormatCalculationUnit;
